<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-110"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
      <!-- タイトル -->
        <label slot="title">
          {{ $t("label.location.mapxusManage") }}
        </label>

        <!-- 編集ボタン -->
        <narrow-down @click="toMapxusEdit" v-auth="{ auth: '010223' }" slot="create">
          {{ $t("button.common.data.edit") }}
        </narrow-down>

        <!-- キャンセルボタン -->
        <sp-smart-button @click="backOwnerSettings" slot="cancel">
          {{ $t("button.common.cancel") }}
        </sp-smart-button>
      </head-title>
    </el-row>

    <!--  body start  -->
    <div slot="body">

      <div>
        <div class="info-area">

          <!-- データプラットフォーム利用情報 -->
          <div class="info-title">
            {{ $t("label.location.dataPlatformUsageInformation") }}
          </div>
          <div class="info-items">
            <!-- 会社名 -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.customerName') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-if="dataInfo.customerName != null && dataInfo.customerName != ''">
                  {{ dataInfo.customerName }}
                </div>
                <div v-else class="no-data-content-style">
                  {{ $t("label.location.noSetting") }}
                </div>
              </div>
            </div>

            <!-- customerID -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.customerId') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-if="dataInfo.customerId != null && dataInfo.customerId != ''">
                  {{ dataInfo.customerId }}
                </div>
                <div v-else class="no-data-content-style">
                  {{ $t("label.location.noSetting") }}
                </div>
              </div>
            </div>

            <!-- サブスクリプションキー -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.subscriptionKey') }}
              </div>
              <div class="info-item-content text-word-break">
                <div v-if="dataInfo.subscriptionKey != null && dataInfo.subscriptionKey != ''">
                  {{ dataInfo.subscriptionKey }}
                </div>
                <div v-else class="no-data-content-style">
                  {{ $t("label.location.noSetting") }}
                </div>
              </div>
            </div>
          </div>


          <!-- mapxus SDK利用情報 -->
          <div class="info-title">
            {{ $t("label.location.mapxusSDKUsageInformation") }}
          </div>
          <div class="info-items">
            <!-- mapxus SDK -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.mapxusSDK') }}
              </div>
              <div class="info-item-content text-word-break header-background-color sdk-flex">
                <div class="width-50">
                  {{ $t('label.location.appID') }}
                </div>
                <div>
                  {{ $t('label.location.secret') }}
                </div>
              </div>
            </div>

            <!-- web -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.web') }}
              </div>
              <div class="info-item-content text-word-break sdk-flex">
                <div class="width-50">
                  <span v-if="dataInfo.webAppId != null && dataInfo.webAppId != ''">
                    {{ dataInfo.webAppId }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>


                <div>
                  <span v-if="dataInfo.webSecret != null && dataInfo.webSecret != ''">
                    {{ dataInfo.webSecret }}
                  </span>
                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Android -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.android') }}
              </div>
              <div class="info-item-content text-word-break sdk-flex">
                <div class="width-50">
                  <span v-if="dataInfo.androidAppId != null && dataInfo.androidAppId != ''">
                    {{ dataInfo.androidAppId }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>


                <div>
                  <span v-if="dataInfo.androidSecret != null && dataInfo.androidSecret != ''">
                    {{ dataInfo.androidSecret }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>
              </div>
            </div>

            <!-- iOS -->
            <div class="info-row">
              <div class="info-item-label">
                {{ $t('label.location.iOS') }}
              </div>
              <div class="info-item-content text-word-break sdk-flex">
                <div class="width-50">
                  <span v-if="dataInfo.iosAppId != null && dataInfo.iosAppId != ''">
                    {{ dataInfo.iosAppId }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>


                <div>
                  <span v-if="dataInfo.iosSecret != null && dataInfo.iosSecret != ''">
                    {{ dataInfo.iosSecret }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- GUIDアクティベーション -->
          <div class="info-title">
            {{ $t("label.location.GUIDActivation") }}
          </div>
          <div class="info-items">

            <!-- GUID ステータス -->
            <div class="info-row">
              <div class="info-item-label content-center">
                {{ $t('label.location.GUIDStatus') }}
              </div>
              <div class="info-item-content text-word-break guid-status-style">

                <div class="content-center">
                  <span v-if="dataInfo.guidStatus" >
                    {{ $t("label.location.valid") }}
                  </span>

                  <span v-else class="no-data-content-style">
                    {{ $t("label.location.noSetting") }}
                  </span>
                </div>

                <div v-auth="{ auth: '010223' }">
                  <narrow-down :disabled="!statusBtnFlg" :class="statusBtnFlg ?'' : 'disabled-btn-style'" :style="statusBtnFlg ?'' : 'cursor: not-allowed;'" @click="activateGUID">
                    {{ $t("label.location.activateGUID") }}
                  </narrow-down>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

      <dialog-confirm
        :key="'create'"
        :clickFlag="false"
        :visible.sync="isDialogConfirmComplete"
        :titleMsg="dialogComplete.title"
        :contentMsg="dialogComplete.content"
        :cancelFlag="cancelFlag"
        :colorFlag="true"
        @on-confirm="updateStatus"
      />
    </div>
    <!--  body end  -->
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import DialogConfirm from "@/components/common/el-dialog-prompt/confirm";
import SpSmartButton from "@/components/common/sp-smart-button";

export default {
  name: "MeetingRoomDetail",
  components: {
    MainLayout: MainLayout,
    headTitle: headTitle,
    LoadingDialog: LoadingDialog,
    narrowDown: narrowDown,
    Menubar: Menubar,
    DialogConfirm: DialogConfirm,
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      orgId: null,
      ownerDetail:null,
      dataInfo: {
        customerName: null,
        customerId: null,
        subscriptionKey: null,
        webAppId: null,
        webSecret: null,
        androidAppId: null,
        androidSecret: null,
        iosAppId: null,
        iosSecret: null,
        guidStatus: false,
      },
      locationFuncFlag:false,
      showLoading: false,
      statusBtnFlg: false,
      isDialogConfirmComplete: false,

      dialogComplete: {
        title: this.$t("label.location.activateGUID"),
        content: this.$t("label.location.activateGUIDContent"),
      },
      cancelFlag: true,
    };
  },
  methods: {

    //編集
    toMapxusEdit() {
      this.$router.push({
        name: "mapxus-manage-settings",
        query: {
          orgId: this.ownerDetail.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    //位置用Mapxus接続情報取得
    getDataInfo() {
      this.showLoading = true
      SystemManageApi.getLocationMapxusInfo(
        this.orgId
      )
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (data != null) {
            if(data.body.mapxusInfo){
              this.dataInfo.customerName = data.body.mapxusInfo.customerName;
              this.dataInfo.customerId = data.body.mapxusInfo.customerId;
              this.dataInfo.subscriptionKey = data.body.mapxusInfo.subscriptionKey;
              this.dataInfo.webAppId = data.body.mapxusInfo.webAppId;
              this.dataInfo.webSecret = data.body.mapxusInfo.webSecret;
              this.dataInfo.androidAppId = data.body.mapxusInfo.androidAppId;
              this.dataInfo.androidSecret = data.body.mapxusInfo.androidSecret;
              this.dataInfo.iosAppId = data.body.mapxusInfo.iosAppId;
              this.dataInfo.iosSecret = data.body.mapxusInfo.iosSecret;
            }
            this.dataInfo.guidStatus = data.body.guidStatus;
            if (data.body.locationFuncFlag && !this.dataInfo.guidStatus) {
              this.statusBtnFlg = true;
            } else {
              this.statusBtnFlg = false;
            }
            this.locationFuncFlag = data.body.locationFuncFlag;
            this.showLoading = false;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    activateGUID() {
      this.isDialogConfirmComplete = true;
    },
    updateStatus() {
      this.showLoading = true
      this.dataInfo.guidStatus = true;
      SystemManageApi.setLocationMapxusInfo(this.orgId, this.dataInfo)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }

          if (data.statusCode == "Success") {
            this.$messageIotSuccess(this.$t("label.location.guidValidSuccess"))
          }

          this.$nextTick(() => {
            this.getDataInfo();
          });
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },
    backOwnerSettings() {
      this.$router.push({
        name: "system-owner-setting-edit",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    }

  },
  created() {
    this.orgId = this.$route.query.orgId;
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail);
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.location.mapxusManage",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  mounted() {
    this.getDataInfo();
  },
};
</script>

<style scoped lang="scss">
.info-area {
  display: flex;
  flex-direction: column;
}

.info-title {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  color: #525250;
  margin-bottom: 24px;
  margin-top: 48px;
}

.info-items {
  border-top: 1px solid #D4D4D4;
  flex: 1;
}

.info-row {
  display: flex;
  border-bottom: 1px solid #D4D4D4;
}

.info-item-label {
  padding: 16px;
  width: 216px;
  background-color: #EBEBE6;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  text-align: left;
  color: #525250;
}

.info-item-content {
  padding: 16px;
  width: calc(100% - 177px);
  background-color: #F7F7F2;
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: #525250;
}

.no-data-content-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-weight: 300;
  font-size: 16px;
  color: #B8B8B3;
}

.width-50 {
  width: 50%;
}

.header-background-color {
  background-color: #EBEBE6;
}
.guid-status-style{
  display: flex;
  justify-content: space-between;
}
.sdk-flex{
  display: flex;
}

.content-center{
  align-content: center;
}

.disabled-btn-style{
  ::v-deep .my-button{
    color:#fff !important;
    background-color: #94c9cc !important;
  }
}
</style>
